<template lang="html">
  <div class="indextitle-wrapper">
    <span class="title-line"></span>
    <div class="title-content-container">
      <span class="title-content">
        <slot name="main"></slot>
      </span>
      <span class="title-sub-content">
        <slot name="sub"></slot>
      </span>
    </div>
    <span class="title-line"></span>
  </div>
</template>

<script>
export default {
  name: "indextitleen"
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.indextitle-wrapper
  width: 8.65rem
  display: flex
  justify-content: center
  .title-line
    margin-top: 0.08rem
    display: inline-block
    width: 1.76rem
    height: 0.05rem
    border-radius: 0.03rem
    background-color: #D2BE68
  .title-content-container
    width: 5.13rem
    display: flex
    flex-direction: column
    align-items: center
    .title-content
      font-size: 0.22rem
      color: #F8F7F0
    .title-sub-content
      margin-top: 0.16rem
      font-size: 0.12rem
      color: #F8F7F0
</style>
